import { useRouter } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ScrollView, StyleSheet, View } from 'react-native';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import BodyXSText from 'shared/components/vxl/typography/primary/body/BodyXSText';
import useDismissToRootTab, {
  Tabs,
} from 'shared/hooks/useDismissToRootTab/useDismissToRootTab';
import SuccessScreen from 'shared/patterns/vxl/SuccessScreen/SuccessScreen';
import theme from 'shared/styles/theme';

const DDApprovedCongrats = ({
  maxApprovedAmount,
}: {
  maxApprovedAmount: string;
}) => {
  const router = useRouter();
  const { t: translatedText } = useTranslation('advance', {
    keyPrefix: 'advanceQualifiedStrings',
  });

  const dismissToTab = useDismissToRootTab();

  const goHome = () => {
    dismissToTab(Tabs.HOME);
  };
  const approvalTitle = translatedText('approvalTitle');

  return (
    <ScrollView contentContainerStyle={styles.scrollView}>
      <SuccessScreen
        primaryButton={{
          label: translatedText('borrowNowButtonLabel'),
          onPress: () => {
            router.replace({
              pathname: '/varo-advance/new',
              params: { skipDdPrompt: 'true' },
            });
          },
          analyticsId: 'borrowNowClicked',
        }}
        secondaryButton={{
          label: translatedText('borrowLaterButtonLabel'),
          onPress: () => {
            goHome();
          },
          analyticsId: 'borrowLaterClicked',
        }}
        visual="HIGH_FIVE_A"
        eyebrowText={translatedText('congratulationTitle')}
        titleText={`${approvalTitle} ${maxApprovedAmount}`}
        content={
          <View>
            <BodyBaseText numberOfLines={0} style={styles.contentText}>
              {translatedText('approvalDescription')}
            </BodyBaseText>
            <BodyXSText numberOfLines={0} style={styles.noteText}>
              {translatedText('noteLabel')}
            </BodyXSText>
          </View>
        }
      />
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  contentText: {
    textAlign: 'center',
  },
  noteText: {
    color: theme.color.text.secondary,
    paddingVertical: theme.spacing.m,
    textAlign: 'center',
  },
  scrollView: {
    flex: 1,
  },
});

export default DDApprovedCongrats;
